export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0120.9dcb4db.jpg";